import type { FileWithUrl } from '@placer-ui/components';
import type {
    ParsedCSVData,
    ParsedDataRow,
} from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { parseSupportFile } from 'features/my-zone/support-requests/components/support-requests-modals/utils/parse-support-file';

const MAX_ROWS = 20000;
const MAX_ROWS_ERROR_MESSAGE = 'File exceeds 20K row limit. Upload a smaller file or split it.';

type CSVValidationResult = {
    isValid: boolean;
    error?: string;
    parsedData?: ParsedCSVData;
};

export const validateSupportFile = (file: FileWithUrl): Promise<CSVValidationResult> => {
    return new Promise((resolve) => {
        parseSupportFile<ParsedDataRow>(
            file.file,
            (results) => {
                const data = results.data;

                if (data.length > MAX_ROWS) {
                    resolve({
                        isValid: false,
                        error: MAX_ROWS_ERROR_MESSAGE,
                    });
                    return;
                }

                resolve({
                    isValid: true,
                    parsedData: {
                        data,
                        fields: results.meta.fields || [],
                        emptyColumns: results.meta.emptyColumns || [],
                        sheetsCount: results.meta.sheetsCount,
                    },
                });
            },
            (error) => {
                resolve({
                    isValid: false,
                    error: `Failed to parse the file: ${error.message}`,
                });
            },
        );
    });
};
